import { FormControl, FormLabel, Stack } from '@mui/joy';
import { camelCase, upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { FormGroupWrapper } from 'core/elements';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { QuoteEntityType } from 'quotes/enums';
import { Size } from 'theme/enums';

import { ItemsToCopyField } from './enums';

interface IProps {
  itemsToCopyValues: ItemsToCopyField[];
}

export const ItemsToCopyFormFields = ({ itemsToCopyValues }: IProps) => {
  const { t } = useTranslation();

  const { control, errors } = useFormContext();

  return (
    <>
      <Stack>
        <FormControl size={Size.MD}>
          <FormLabel>{t('labelCopy')}</FormLabel>
        </FormControl>

        <FormGroupWrapper
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          {itemsToCopyValues.map((field) => {
            return (
              <FormField
                key={field}
                name={field}
                type={InputType.CHECKBOX}
                inputProps={{
                  control,
                  error: errors?.[field],
                  label: t(`label${upperFirst(camelCase(field))}`, {
                    entityType: QuoteEntityType.QUOTE,
                  }),
                  size: Size.SM,
                  disabled: ItemsToCopyField.PARTS === field,
                }}
                fullWidth={false}
              />
            );
          })}
        </FormGroupWrapper>
      </Stack>
    </>
  );
};
